// extracted by mini-css-extract-plugin
export default {"testo":"DatiSanitari_testo__AwJCl","hr":"DatiSanitari_hr__tOMNu","col-75":"DatiSanitari_col-75__vUc6h","col-25":"DatiSanitari_col-25__QEWGJ"};